import { connect } from 'react-redux';
import HomePage from './HomePage';
import { getTranslation } from "../../../reducers/common/localization";
import {
    getCurrentRole,
    getCurrentSubRole,
    getSubRoles,
    getLoading
} from '../../../reducers/account/role';
import {
    getConsentRequestFee, getOperationAvailability, getOrgBalance, getOrgPermissions,
    getOrgType, getPaidTillDate
} from '../../../reducers/organization/organization';
import {
    getNotificationsData,
    loadingNotifications, fetchGetInsertorNotifications, fetchGetValidatorNotifications,
    getApplicantNotifications, getSysAdminNotifications, getAnchorNotifications
} from "../../../reducers/common/notifications";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        role: getCurrentRole(state),
        currentSubRole: getCurrentSubRole(state),
        subRoles: getSubRoles(state),
        loading: getLoading(state),
        orgPermissions: getOrgPermissions(state),
        loadingNotifications: loadingNotifications(state),
        notifications: getNotificationsData(state),
        orgType: getOrgType(state),
        balance: getOrgBalance(state),
        consentRequestFee: getConsentRequestFee(state),
        paidTillDate: getPaidTillDate(state),
        operationAvailability: getOperationAvailability(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSysAdminNotifications: () => {
            dispatch(getSysAdminNotifications());
        },
        getInsertorNotification: () => {
            dispatch(fetchGetInsertorNotifications());
        },
        getValidatorNotifications: () => {
            dispatch(fetchGetValidatorNotifications());
        },
        getApplicantNotifications: () => {
            dispatch(getApplicantNotifications());
        },
        getAnchorNotifications: () => {
            dispatch(getAnchorNotifications());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/commonComponents/homePage/HomePage.container.js